import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

export function CookieConsentBanner() {
  useEffect(() => {
    CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'box',
          position: 'bottom left',
          equalWeightButtons: false,
          flipButtons: false,
        },
        preferencesModal: {
          layout: 'box',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },

      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        analytics: {
          enabled: false,
          readOnly: false,
        },
      },

      language: {
        default: 'fr',
        translations: {
          fr: {
            consentModal: {
              title: 'Nous utilisons des cookies',
              description:
                'Consentink utilise des cookies techniques nécessaires au fonctionnement de l\'application. Avec votre accord, nous utilisons également des cookies d\'analyse pour améliorer nos services.',
              acceptAllBtn: 'Tout accepter',
              acceptNecessaryBtn: 'Refuser',
              showPreferencesBtn: 'Personnaliser',
              footer: `
                <a href="/politique-de-confidentialite" target="_blank">Politique de confidentialité</a>
                <a href="/cgu" target="_blank">CGU</a>
              `,
            },
            preferencesModal: {
              title: 'Préférences de cookies',
              acceptAllBtn: 'Tout accepter',
              acceptNecessaryBtn: 'Tout refuser',
              savePreferencesBtn: 'Enregistrer mes choix',
              closeIconLabel: 'Fermer',
              serviceCounterLabel: 'Service|Services',
              sections: [
                {
                  title: 'Utilisation des cookies',
                  description:
                    'Nous utilisons des cookies pour assurer le fonctionnement de l\'application et, avec votre consentement, pour analyser notre trafic. Vous pouvez modifier vos préférences à tout moment.',
                },
                {
                  title: 'Cookies strictement nécessaires <span class="pm__badge">Toujours actifs</span>',
                  description:
                    'Ces cookies sont indispensables au fonctionnement de l\'application (authentification, session, sécurité). Ils ne peuvent pas être désactivés.',
                  linkedCategory: 'necessary',
                },
                {
                  title: 'Cookies d\'analyse',
                  description:
                    'Ces cookies nous permettent de mesurer l\'audience et d\'améliorer les performances de l\'application (ex : Sentry pour le suivi des erreurs). Aucune donnée n\'est vendue à des tiers.',
                  linkedCategory: 'analytics',
                },
              ],
            },
          },
        },
      },
    });
  }, []);

  return null;
}